import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";

const initialState: any = {
};

const objectSlice = createSlice({
  name: "object",
  initialState,
  reducers: {

    setObjectDetails: (state, _action) => {
      // console.log(_action.payload)
      return { ...state, ..._action.payload };
    },
    clearObject: () => {
      return {}
    }
  },
});

export const isQueryLoading = (state: RootState) => (state.object)?.isLoading
export const getObjectFields = (state: RootState) => (state.object)?.fields
export const getObjectChildRelationships = (state: RootState) => (state.object)?.childRelationships
export const getObjectName = (state: RootState) => (state.object)?.objectName
export const getObjectSelectedFields = (state: RootState) => (state.object)?.selectedObjectFields
export const getLatestRunAt = (state: RootState) => (state.object)?.runat
export const getObjectRecords = (state: RootState) => (state.object)?.records
export const getObjectFilter = (state: RootState) => (state.object)?.filter
export const getObjectFilterSOQL = (state: RootState) => (state.object)?.soql
export const getObjectFilterWith = (state: RootState) => (state.object)?.with
export const getObjectFilterWithout = (state: RootState) => (state.object)?.without
export const getObjectSeletedRecords = (state: RootState) => (state.object)?.seletedRecords
export const getSelectedTableName = (state: RootState) => (state.object)?.tableName
export const getFilters = (state: RootState) => (state.object)?.filters
export const getCrossFilters = (state: RootState) => (state.object)?.crossFilters
export const getObjectDetailsToSaveAsConfig = (state: RootState) => {
  let object = JSON.parse(JSON.stringify(state.object))
  if (object?.records) {
    delete object.records
  }
  if (object?.seletedRecords) {
    delete object.seletedRecords
  }
  // console.log(object)
  return object
}

export const { setObjectDetails, clearObject } = objectSlice.actions;
export default objectSlice.reducer;
